import React from 'react';
import { Shield, CheckCircle, Award, Star, MapPin, Users } from 'lucide-react';
export function TrustStrip() {
  const trustBadges = [{
    icon: Shield,
    text: 'Fully Licensed'
  }, {
    icon: CheckCircle,
    text: 'Fully Insured'
  }, {
    icon: Star,
    text: '5.0 Star Rated'
  }, {
    icon: Users,
    text: '437+ Reviews'
  }, {
    icon: MapPin,
    text: 'Huntingdale Based'
  }, {
    icon: Award,
    text: 'Quality Guaranteed'
  }];
  // Duplicate for seamless marquee
  const marqueeItems = [...trustBadges, ...trustBadges, ...trustBadges];
  return <div className="bg-cream border-b border-gray-200 py-8 md:pt-24 md:pb-8 overflow-hidden relative" data-id="element-559">
      {/* Gradient masks for smooth fade on edges */}
      <div className="absolute left-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-r from-cream to-transparent z-10 pointer-events-none" data-id="element-560"></div>
      <div className="absolute right-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-l from-cream to-transparent z-10 pointer-events-none" data-id="element-561"></div>

      <div className="flex whitespace-nowrap animate-marquee w-max" data-id="element-562">
        {marqueeItems.map((badge, index) => <div key={index} className="flex items-center mx-4 md:mx-8" data-id="element-563">
            <div className="flex items-center gap-2.5 bg-white px-5 py-2.5 rounded-full shadow-sm border border-gray-100 text-navy font-bold text-sm md:text-base" data-id="element-564">
              <badge.icon className="w-5 h-5 text-orange" data-id="element-565" />
              <span data-id="element-566">{badge.text}</span>
            </div>
            {/* Separator dot */}
            <div className="w-1.5 h-1.5 rounded-full bg-gray-300 ml-8 md:ml-16 hidden sm:block" data-id="element-567"></div>
          </div>)}
      </div>
    </div>;
}